var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('SetParam',{attrs:{"pushStatus":_vm.pushStatus,"relationId":_vm.relationId,"relationName":_vm.relationName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }